import * as actionTypes from './actionTypes';

export const register = (values) => {
  return {
    type: actionTypes.REGISTER,
    payload: values
  };
};
